import { t } from '../i18n/I18n';
import { TIER_NAMES, type PaidTier } from '../state/demoTier';
import { Alert } from './Alert';

const TIER_GIVES = { pro: 'subscriptionDescription', proPlus: '#UpgradeProPlusDescription', proPlusPlus: '#UpgradeProPlusPlusDescription' } as const;

/** What a plan gives, and that the web cannot sell it yet: the plan is bought in the app (В2). */
export function PaywallDialog({ tier, onClose }: { tier: PaidTier; onClose: () => void }) {
  return <Alert title={TIER_NAMES[tier]} className="paywall-alert" onClose={onClose}
    text={<>{t(TIER_GIVES[tier])}<br />{t('#WebPaywallBuyInApp', TIER_NAMES[tier])}</>}
    primary={{ label: t('Ok'), onSelect: onClose }} />;
}
